export const myHeaders = () => {
  // const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  let SendData = {};
  if (localStorage.getItem("access_token") == null) {
    SendData = {
      "Content-Type": "multipart/form-data",
      //   "Content-Type": "application/json",
    };
  } else {
    SendData = {
      "Content-Type": "multipart/form-data",
      //   "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      "Email-Id": `${localStorage.getItem("Email")}`,
    };
  }
  return SendData;
};
